import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { CapexOpexFormNew } from './capex-opex-form-new';

export type CapexOpexDrawerProps = {
  readonly formId: string;
  readonly project: Project;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly isOpen: boolean;
};

export function CapexOpexDrawerNew({formId, project, onSubmit, onClose, isOpen }: CapexOpexDrawerProps) {
     const { t } = useTranslation(['projects']);

     const footer = (
       <>
         <Button size="lg" color="neutral" onClick={onClose}>
           {t('Cancel')}
         </Button>
         <Button type="submit" form={formId} size="lg" color="primary">
           {t('Save')}
         </Button>
       </>
     );

     return (
       <Drawer title={t('Capex & Opex')} open={isOpen} onClose={onClose} footer={footer}>
         <CapexOpexFormNew
           id={formId}
           project={project}
           onSubmit={(data) => {
             onSubmit(data, t('Capex and Opex section has been updated'));
           }}
         />
       </Drawer>
     );
}
